import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import Button from '@material-ui/core/Button';

import CloseIcon from "../Common/CloseIcon";
import images from "../../assets/img/images";

const styles = {
    container: {
        width: 380,
        height: 250
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
    },
    warning: {
        right: -180,
        top: 80
    },
    warningMessage: {
        top: 100,
        left: 45,
        width: "290px",
    },
    buttons: {
        display: "table",
        margin: "0 auto",
        left: 30,
        top: 152
    }
};

/**
 * Confirmation asked before printing every bin label of a level, since a single
 * click can send a few hundred labels to the printer.
 */
const BulkPrintConfirmation = withStyles(styles)((props) => {
    const {
        classes,
        count,
        format,
        zoneName,
        handleClose,
        handleConfirm
    } = props;

    const message = I18n.get("label_printer_bulk_confirm")
        .replace("{count}", count)
        .replace("{format}", format)
        .replace("{zone}", zoneName || "-");

    return (
        <div className={classes.container}>
            <div className={classes.close}>
                <CloseIcon closeFunction={handleClose} />
            </div>
            <div style={{ height: 0 }}>
                <img src={images.warningTriangleOrange} className={classes.warning} alt="warning"></img><br />
                <div className={classes.warningMessage}>{message}</div>
            </div>
            <div className={classes.buttons}>
                <Button onClick={() => { handleClose() }} color="primary">
                    {I18n.get("site_cancel")}
                </Button>
                <Button onClick={() => { handleConfirm() }} style={{ top: "-4px", left: "14px" }} variant="contained" color="primary">
                    {I18n.get("site_confirm")}
                </Button>
            </div>
        </div>
    );
});

export default BulkPrintConfirmation;
